import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './App.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar, utils  } from "react-modern-calendar-datepicker";
import { addDays, delegacionesPorModulo, diasPorServicio, DNIestaRegistrado, DNIestaRegistradoMultiple, horasPorDia, serviciosPorDelegacion, todosModulos } from './APIfuncs/APIgetters';
import {barrio} from "./Utilidades/Barrios_BA";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { style } from '@mui/system';
import { useEffect } from 'react';
import { IconButton, TextField } from '@mui/material';
import * as Yup from "yup";
import CampoDeTexto from './Utilidades/CampoDeTexto';
import { useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { CreateSharp } from '@mui/icons-material';
import { insertarTurno } from './APIfuncs/APIposters';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import NuevoTurno from "./components/NuevoTurno"
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export default function Test() {

  // const idModuloDeportes = 86;
  // const idDelNiniez = 109;
  // const idDepCulMunro = 79;
  // const idServicioTenis = ["158", "159", "160"];
  // const idSocialNinies = [216, 218];
  // const turnoMaximoCultura = 8;

  const idModuloDeportes = 73;
  const idDelNiniez = 67;
  const idDepCulMunro = 71;
  const idServicioTenis = ["101", "102", "103"];
  const idSocialNinies = [162, 163];
  const turnoMaximoCultura = 2;


  const [formEnviado, setFormEnviado] = useState(false);
  const [traminteEnviado, setTraminteEnviado] = useState(false);
  const [ubicacionEnviada, setUbicacionEnviada] = useState(false);
  const [tipoTraminteEnviado, setTipoTraminteEnviado] = useState(false);
  const [fechaEnviada, setFechaEnviada] = useState(false);
  const [datosPersonalesEnviados, setDatosPersonalesEnviados] = useState(false);
  const [mostrarHoras, setMostrarHoras] = useState(false);
  
  const [nombreModulo, setNombreModulo] = useState("");
  const [nombreDelegacion, setNombreDelegacion] = useState("");
  const [nombreServicio, setNombreServicio] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();

  const [hayParametroModulo, setHayParametroModulo] = useState(false);
  const [hayParametroDependencia, setHayParametroDependencia] = useState(false);
  const [hayParametroServicio, setHayParametroServicio] = useState(false);
  const [loading, setLoading] = useState(false);
  const [necesitoLupita, setNecesitoLupita] = useState(true);
  const [checked, setChecked] = useState(false);
  const [checkedNinio, setCheckedNinio] = useState(false);
  const [checkedTenisDouble, setCheckedTenisDouble] = useState(false);
  const [checkedTurnoDoble, setCheckedTurnoDoble] = useState(false);
  const [cantidadTurnos, setCantidadTurnos] = useState(null);
  const [enviadosDatosInteresado, setEnviadosDatosInteresado] = useState(false);

  const [nuevoTurnoInfo, setNuevoTurnoInfo] = useState(null);

  const theme = createTheme({
    palette: {
      primary: {
        light: '#757ce8',
        main: '#3f50b5',
        dark: '#002884',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ab3897',
        main: '#97077D',
        dark: '#690457',
        contrastText: '#fff',
      },
      desmarcado: {
        light: '#e6e6e6',
        main: '#e0e0e0',
        dark: '#9c9c9c',
        contrastText: '#97077D',
      },
    },
  });
  
  const textoPreguntas = { width: '100%', flexShrink: 0, fontFamily: "Brandon", fontWeight: 1000, fontSize: "20px", textAlign: "left" };
  const iconosPreguntas = {"minWidth": "10px", "width": "15px", "height": "30px", "borderRadius": "20px", "marginRight": "5px"};
  const respuestaElegida = {color: 'text.secondary', textAlign: "left", marginLeft: "40px"}

  const [datos, setDatos] = useState({
    idModulo: 0,
    idDelegacion: 0,
    idServicio: 0,
    dia: "",
    diaCompleto: "",
    hora: "",
    tipoDNIUser: "dni",
    dniUser: 0,
    emailUser: "",
    nombreUser: "",
    apellidoUser: "",
    telUser: "",
    direccionUser: "",
    localidadUser: "",
    dniInteresado: null,
    nombreInteresado: null,
    apellidoInteresado : null,
    interesados: [],
    cantidad: null
});

  const [modulos, setModulos] = useState(null);
  const [delegaciones, setDelegaciones] = useState();
  const [servicios, setServicios] = useState();
  const [opcionesServicios, setOpcionesServicios] = useState([]);
  const [horas, setHoras] = useState("");
  const [necesitaCheckDNI, setNecesitaCheckDNI] = useState(false);
  const [necesitaCheckDNICultura, setNecesitaCheckDNICultura] = useState(false);
  const [tieneUnTurnoActivo, setTieneUnTurnoActivo] = useState(false);
  const [esDNIValido, setEsDNIValido] = useState(false);
  const [hayError, setHayError] = useState(false);
  const [mostrarNoHayHoras, setMostrarNoHayHoras] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const defaultDay = utils().getToday();
  const [selectedDay, setSelectedDay] = useState(null);
  const [disabledDays, setDisabledDays] = useState([{}]);
  let diasDisponibles= [];
  let disabledDaysAux = addDays(defaultDay);

  const [aviso, setAviso] = useState("");
  const [open, setOpen] = useState(false);
  const [openDNI, setOpenDNI] = useState(false);
  const [dniValue, setDniValue] = useState('');


  const manejarInvitado = () => {
    if(checked) setChecked(false);
    else setChecked(true)
  }
  const manejarCheckedNiniez = () => {
    setCheckedNinio(!checkedNinio);
  }
  const manejarTenisDouble = () => {
    if(checkedTenisDouble) setCheckedTenisDouble(false);
    else setCheckedTenisDouble(true)
  }


  const cargarOpcionesServicio = (servicio) => {
    opcionesServicios.push({value: servicio, label: servicio.nombre})
  }

    const myCustomLocale = {
      // months list by order
      months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
      ],
    
      // week days by order
      weekDays: [
        {
          name: 'Domingo', // used for accessibility 
          short: 'D', // displayed at the top of days' rows
          isWeekend: true, // is it a formal weekend or not?
        },
        {
          name: 'Lunes',
          short: 'L',
        },
        {
          name: 'Martes',
          short: 'M',
        },
        {
          name: 'Miércoles',
          short: 'X',
        },
        {
          name: 'Jueves',
          short: 'J',
        },
        {
          name: 'Viernes',
          short: 'V',
        },
        {
          name: 'Sábado',
          short: 'S',
          isWeekend: true,
        },
      ],
    
      // just play around with this number between 0 and 6
      weekStartingIndex: 0,
    
      // return a { year: number, month: number, day: number } object
      getToday(gregorainTodayObject) {
        return gregorainTodayObject;
      },
    
      // return a native JavaScript date here
      toNativeDate(date) {
        return new Date(date.year, date.month - 1, date.day);
      },
    
      // return a number for date's month length
      getMonthLength(date) {
        return new Date(date.year, date.month, 0).getDate();
      },
    
      // return a transformed digit to your locale
      transformDigit(digit) {
        return digit;
      },
    
      // texts in the date picker
      nextMonth: 'Next Month',
      previousMonth: 'Previous Month',
      openMonthSelector: 'Open Month Selector',
      openYearSelector: 'Open Year Selector',
      closeMonthSelector: 'Close Month Selector',
      closeYearSelector: 'Close Year Selector',
      defaultPlaceholder: 'Select...',
    
      // for input range value
      from: 'from',
      to: 'to',
    
    
      // used for input value when multi dates are selected
      digitSeparator: ',',
    
      // if your provide -2 for example, year will be 2 digited
      yearLetterSkip: 0,
    
      // is your language rtl or ltr?
      isRtl: false,
    }
    
    
    

    const eliminarDia = (dia) => {
      let indexAux = disabledDaysAux.findIndex(element => (element.day == dia.day && element.month == dia.month && element.year == dia.year));
      if (indexAux > -1) disabledDaysAux.splice(indexAux, 1);
    }

    const habilitarDias = () => {
      diasDisponibles.map(dia => eliminarDia(dia));
    }

    const fechaADia = (fecha) => {

      let mesAux = fecha.month;
      let diasAux = fecha.day;

      if (fecha.month < 10) {
        mesAux = "0"+fecha.month;
      }
      if (fecha.day < 10) {
        diasAux = "0"+fecha.day;
      }
      
      const weekDays = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      let diaAux = new Date(fecha.year + "-" + mesAux + "-" + diasAux + "T00:00:00");
      
      return (weekDays[diaAux.getDay()]);
    }

    const abrirPrimerDia = async(listaDias, servicio) => {
      for (let i = 0; i < listaDias.length; i++) {
        const especifico = listaDias[i];
        if (especifico.year >= defaultDay.year && especifico.month >= defaultDay.month && especifico.day >= defaultDay.day) {
          setSelectedDay(especifico);
          
          const horaAux = await horasPorDia(setHoras, servicio, especifico.day, especifico.month, especifico.year, setLoading);
          console.log(horaAux)
          noHayHoras(horaAux);
          setMostrarHoras(true);

          i = listaDias.length;
        }
      }
    }

    const noHayHoras = (horas) => {
      if (horas.status == "error") {
        setMostrarNoHayHoras(true);
        return;
      }
      else if ((horas.filter(horas => horas.cupo > 0)).length < 1) {
        setMostrarNoHayHoras(true);
        return;
      }
      setMostrarNoHayHoras(false);
    }

    
  
    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleDisabledSelect = () => {
      setAviso(
        <div>
          <p>
            El día que intento seleccionar no tiene {datos.idDelegacion==idDepCulMunro? "entradas" :"cupos" } disponibles. <br/><br/>
            Por favor, seleccione otro.
          </p>
        </div>
      )
      handleOpen()
    }

    const manejarDniMultiple = async (payload) => {
      let textoAux = "<div>";
      let setHaySinRegistro =(false);
      let setHayDniBloqueado= (false);
      const dataAux = await DNIestaRegistradoMultiple(payload, setLoading);
      console.log(dataAux)
      dataAux.forEach(dni => {
        if (!dni.registered) {
          textoAux += `</p> La persona con DNI: <b>${dni.documentNumber}</b> no se encuentra registrado como Usuario Asociado de la Secretaría de Deportes. </p>`;
          setHaySinRegistro=(true);
        }
        else if (dni.isBookingEnabled) {
          textoAux += `<p> La persona con DNI: <b>${dni.documentNumber}</b> se encuentra bloqueada.</p>`;
          setHayDniBloqueado=(true);
        }
      });
      textoAux += "<br/>"
      if (setHaySinRegistro) {
        textoAux += `<p> Si deseas asociarte, hace clic <b><a href="http://www.vicentelopez.gov.ar/mibarriovecinos/Account/Login" target="_blank">ACÁ</a></b></p>`;
      }
      if (setHayDniBloqueado) {
        textoAux += `<p> Si desea desbloquear el/los usuario/s deberá acercarse a la sede de Deportes correspondiente.
        </p>`;
      }
      textoAux += "</div>"
      return textoAux;
    }

    const sinDuplicados = (dni, listaInteresados) => {
      if (listaInteresados.length >= 2) {
        for (let i = 1; i < listaInteresados.length; i++) {
          const element = listaInteresados[i].dni;
          if(element == dni) return false;
        }
      }
      return true;
    }

    const desaparecerLupa = () =>{
      setNecesitoLupita(false);
    }

    const aparecerLupa = () =>{
      if(!selectedOptions) setNecesitoLupita(true);
      
    }

    const verificarDNICultura = async (dni) => {
      

      const checkAux = await diasPorServicio(selectedOptions.idServicio, defaultDay.month, defaultDay.year, setLoading, {dni:[`${dni}`]}, setTieneUnTurnoActivo)
      console.log(dni)
      console.log(checkAux)
      console.log(selectedDay)

      const estaHabilitado = await tengoDiaHabilitado(checkAux, selectedDay);
      
      if (checkAux.status == "error" || !estaHabilitado || dni <= 999999){
        if (dni <= 999999) {
          setEsDNIValido(false);
          setAviso(
            <div>
              <p> Por favor, ingrese un dni válido </p>
            </div>
          )
          handleOpen();
          return;
        }
        else if (checkAux.info == "El DNI posee turnos anteriormente activos"){
          setEsDNIValido(false);
          setAviso(
            <div>
              <p> El DNI ingresado ya cuenta con {(selectedOptions.cupoMaximo? selectedOptions.cupoMaximo : 1)} reservas para esta función. Este es el máximo permitido. </p>
            </div>
          )
          handleOpen()
        }
        else{
          setNuevoTurnoInfo({...nuevoTurnoInfo, status: "error", data: checkAux.info})
          setFormEnviado(true);
        }
      }
      else if ((checkAux[0].turnoActivo + cantidadTurnos) > (selectedOptions.cupoMaximo? selectedOptions.cupoMaximo : 1)){
        setEsDNIValido(false);
        setAviso(
          <div>
            <p> Usted ya cuenta con {checkAux[0].turnoActivo} reservas activas, solamente pueden sacarse hasta {(selectedOptions.cupoMaximo? selectedOptions.cupoMaximo : 1)} entradas. Por favor, disminuya la cantidad de entradas o cancele sus entradas activas. </p>
          </div>
        )
        handleOpen()
        setTieneUnTurnoActivo(false)
      }
      else if (!checkAux[0].turnoActivo && parseInt(checkAux[0].cantidad) < cantidadTurnos){
        setEsDNIValido(false);
        setAviso(
          <div>
            <p> La función solo posee {checkAux[0].cantidad} entrada/s disponible/s, si desea reservarla/s regrese a la selección de función y marque la opción para reservar {checkAux[0].cantidad} Entrada/s. </p>
          </div>
        )
        handleOpen()
      }
      else if (estaHabilitado) {
        setEsDNIValido(true);
      }
    }

    const tengoDiaHabilitado = async (listaDias, diaSeleccionado) => {
      for (let i = 0; i < listaDias.length; i++) {
        const element = listaDias[i];
        if (element.day == diaSeleccionado.day && element.month == diaSeleccionado.month && element.year == diaSeleccionado.year) {
          console.log("Habilitado")
          return true;
        }
      }
      console.log("No Habilitado")
      return false;
    }

    const recibirModuloParam = async () => {
      console.log("Versión: 19/07 PRD")
      const idIngresada = searchParams.get("modulo");
      const hayDepParam = searchParams.get("dependencia");
      let agria = await delegacionesPorModulo(setDelegaciones, idIngresada, setLoading);
      if (!agria.status) {
        recibirDependenciaParam(agria);
        if(!hayDepParam)setDatos({...datos, idModulo: idIngresada});
        setTraminteEnviado(true);
        setHayParametroModulo(true);
        if(idIngresada == idModuloDeportes) setNecesitaCheckDNI(true);
      }
      else if (delegaciones) {
        setDelegaciones();
      }
    }

    const recibirDependenciaParam = async (modulos) => {
      const idIngresada = searchParams.get("dependencia");
      const moduloParam = searchParams.get("modulo");
      const haySerParam = searchParams.get("servicio");
      var encontrado = false;
      for (var i = 0; i < modulos.length; i++) {
          if (modulos[i].idDelegacion == idIngresada) {
              encontrado = true;
              break;
          }
      }
      if (encontrado && moduloParam!=idModuloDeportes) {
        let agria = await serviciosPorDelegacion(setServicios, idIngresada, setLoading);
        if (!agria.status && moduloParam && (opcionesServicios.length == 0)) {
          if(idIngresada == idDepCulMunro) setNecesitaCheckDNICultura(true);
            setHayParametroDependencia(true);
            setUbicacionEnviada(true);
            agria.filter(serv => serv.activo == "1").map(tipoTramite => cargarOpcionesServicio(tipoTramite));
            if(!haySerParam)setDatos({...datos, idDelegacion: idIngresada, idModulo: moduloParam});
            recibirServicioParam(agria)
        }
        else{
          setDatos({...datos, idDelegacion: idIngresada, idModulo: moduloParam})
        }
      }
      // else if (servicios) {
      //   setServicios();
      // }
    }

    const recibirServicioParam = async (dependencias) => {
      const moduloParam = searchParams.get("modulo");
      const depParam = searchParams.get("dependencia");
      const idIngresada = searchParams.get("servicio");
      var encontrado = false;
      for (var i = 0; i < dependencias.length; i++) {
          if (dependencias[i].idServicio == idIngresada) {
              encontrado = true;
              break;
          }
      }
      if (encontrado && moduloParam!=idModuloDeportes) {
        diasDisponibles = await diasPorServicio(idIngresada, defaultDay.month, defaultDay.year, setLoading, {dni: [`${datos.dniUser}`]});
        if (diasDisponibles.status !== "error") {
          setDatos({...datos, idDelegacion: depParam, idModulo: moduloParam, idServicio: idIngresada});
          setTipoTraminteEnviado(true);
          habilitarDias();
          setHayParametroServicio(true);
          await setDisabledDays(disabledDaysAux);
        }
        else{
          setAviso(
            <div>
              <p>
              {datos.idDelegacion==idDepCulMunro? "Entradas agotadas." :"El trámite/actividad seleccionado no posee turnos disponibles."}
              </p>
            </div>
          );
          handleOpen();
        }
      }
      }
  
    useEffect(() => {
      todosModulos(setModulos, setLoading);
      if (!delegaciones) {
        recibirModuloParam();
        // recibirDependenciaParam();
      }
    },[])

    const VALORES_INICIALES = {
      dni: "",
      nombre: "",
      apellido: "",
      domicilio: "",
      correo: "",
      celular: "",
      dniInteresado: "", 
      nombreInteresado: "", 
      apellidoInteresado: "",
    }
      
    const FORM_VALIDATION = Yup.object().shape({
      nombre: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido')
          .required("Ingrese un nombre"),
      apellido: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido')
          .required("Ingrese un apellido"),
      domicilio: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ0-9_.-.\s]*$/ , 'Ingrese un domicilio válido')
          .required("Ingrese un domicilio"),
      correo: Yup.string()
          .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ , 'Ingrese un Email válido')
          .required("Ingrese un correo"),
      celular: Yup.string()
          .matches(/^[\[0-9\]*]{1,40}$/ , 'Ingrese un celular válido (sin "+" ni "-")')
          .required("Ingrese un celular"),
      dniInteresado: Yup.number()
          .typeError("Ingrese un DNI válido (sin espacios ni '.')"),
      nombreInteresado: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido'),
      apellidoInteresado: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido'),
    });

    const FORM_VALIDATION_DNI = Yup.object().shape({
      dni: Yup.number()
          .typeError("Ingrese un DNI válido (sin espacios ni '.')")
          .required("Ingrese un DNI"),
      nombre: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido')
          .required("Ingrese un nombre"),
      apellido: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido')
          .required("Ingrese un apellido"),
      domicilio: Yup.string()
          .matches(/^[a-zA-ZÀ-ÿ0-9_.-.\s]*$/ , 'Ingrese un domicilio válido')
          .required("Ingrese un domicilio"),
      correo: Yup.string()
          .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ , 'Ingrese un Email válido')
          .required("Ingrese un correo"),
      celular: Yup.string()
          .matches(/^[\[0-9\]*]{1,40}$/ , 'Ingrese un celular válido (sin "+" ni "-")')
          .required("Ingrese un celular"),
    });

    const elegirEsquemaVal = () => {
      if (necesitaCheckDNI) {
        return FORM_VALIDATION;
      }
      return FORM_VALIDATION_DNI;
    }

  return (
    
    <div>
      {/* VENTANA DE DNIs EXTRA */}
      <Dialog
        open={openDNI}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{"textAlign": "center", "color": "#97077D", "fontWeight": "bold"}} >{"Ingrese el DNI de los demás jugadores:"}</DialogTitle>
        <DialogContent sx={{px: "40px"}}>
          <Formik
            initialValues={{dni1: "", dni2: "", dni3: ""}}
            validationSchema={Yup.object().shape({
              dni1: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')")
                  .required("Ingrese un DNI"),
              dni2: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')"),
              dni3: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')")
              })}
            
            onSubmit={async(valores) =>{
              var checkAux = false;
              let avisoAux = "";
              if (!(datos.dniUser === valores.dni1)) {
                if (!checkedTenisDouble) {
                  avisoAux = await manejarDniMultiple([{documentNumber: `${valores.dni1}`}], setLoading);
                    checkAux = (avisoAux === "<div><br/></div>");
                }
                  
                  if (checkedTenisDouble) {
                    if (!(datos.dniUser === valores.dni2 || datos.dniUser === valores.dni3 || 
                      valores.dni1 === valores.dni2 || valores.dni1 === valores.dni3 || valores.dni2 === valores.dni3)) 
                    {
                      const payloadAux = [{documentNumber: `${valores.dni1}`}, {documentNumber: `${valores.dni2}`}, {documentNumber: `${valores.dni3}`}]
                      avisoAux = await manejarDniMultiple(payloadAux);
                      checkAux = (avisoAux === "<div><br/></div>");
                    }
                    else {checkAux = false;avisoAux = "<div><p>Por favor, no ingresar DNIs duplicados</p></div>";}
                  }
              }
              else avisoAux = "<div><p>Por favor, no ingresar DNIs duplicados</p></div>";

              if (checkAux) {
                if (checkedTenisDouble) {
                  diasDisponibles = await diasPorServicio(selectedOptions.idServicio, defaultDay.month, defaultDay.year, setLoading, {dni:[`${valores.dni1}`, `${valores.dni2}`, `${valores.dni3}`, `${datos.dniUser}`]});
                }
                else diasDisponibles = await diasPorServicio(selectedOptions.idServicio, defaultDay.month, defaultDay.year, setLoading, {dni:[`${valores.dni1}`, `${datos.dniUser}`]});
                
                if (diasDisponibles.status !== "error") {
                  const payload = [{documentNumber: `${valores.dni1}`}, {documentNumber: `${valores.dni2}`}, {documentNumber: `${valores.dni3}`}]
                    const dataAux = await DNIestaRegistradoMultiple(payload, setLoading);
                    setDatos({...datos, idServicio: selectedOptions.idServicio, interesados: [{dni: valores.dni1, 
                      nombre: dataAux[0].nombre, 
                      apellido: dataAux[0].apellido}]});
                      const datosAux = {...datos, idServicio: selectedOptions.idServicio, interesados: [{dni: valores.dni1, 
                        nombre: dataAux[0].nombre, 
                        apellido: dataAux[0].apellido}]};
                      if (checkedTenisDouble) {
                        setDatos({...datosAux, interesados: [...datosAux.interesados,
                        {dni: valores.dni2, 
                          nombre: dataAux[1].nombre, 
                          apellido: dataAux[1].apellido},
                        {dni: valores.dni3, 
                          nombre: dataAux[2].nombre, 
                          apellido: dataAux[2].apellido}]});
                      }
                    setTipoTraminteEnviado(true);
                    habilitarDias();
                    // abrirPrimerDia(diasDisponibles, selectedOptions.idServicio);
                    await setDisabledDays(disabledDaysAux);
                  }
                  else{
                    setAviso(
                      <div>
                        <p>
                        {datos.idDelegacion==idDepCulMunro? "Entradas agotadas." :"El trámite/actividad seleccionado no posee turnos disponibles."}
                        </p>
                      </div>
                    );
                    handleOpen();
                  }
                setOpenDNI(false);
              }
              else{
                setAviso(<div dangerouslySetInnerHTML={{ __html: avisoAux }} />)
                handleOpen()
              }
            }}>
            {( { errors, }) => (
                <Form className='formulario'>
                  <div>
                      <CampoDeTexto 
                      type="number" 
                      id="dni1" 
                      name='dni1'
                      label="DNI"
                      />
                  </div>                  
                  {checkedTenisDouble &&<><div>
                      <CampoDeTexto 
                      type="number" 
                      id="dni2" 
                      name='dni2'
                      label="DNI"
                      />
                  </div>                  
                  <div>
                      <CampoDeTexto 
                      type="number" 
                      id="dni3" 
                      name='dni3'
                      label="DNI"
                      />
                  </div></>}               
                  <div className='buttonContainer'>
                  <button type='button' className='formulario-atrasButton' onClick={() => {setOpenDNI(false);}}>Atras</button>
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
            
        </DialogContent>
        {/* <DialogActions>
          {!formEnviado && <Button onClick={handleClose}>Entendido</Button>}
          {(formEnviado || hayError) && <Button href='/'>Entendido</Button>}
        </DialogActions> */}
      </Dialog>

      {/* VENTANA DE AVISO CUSTOM */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{"textAlign": "center", "color": "#97077D", "fontWeight": "bold"}} >{"Importante:"}</DialogTitle>
        <DialogContent sx={{px: "40px"}}>
          <DialogContentText id="alert-dialog-slide-description">
            {aviso}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!formEnviado && <Button onClick={handleClose} color='primary' variant='contained'>Entendido</Button>}
          {(formEnviado || hayError) && <Button href='/'>Entendido</Button>}
        </DialogActions>
      </Dialog>

      
      {/* VENTANA DE CARGA */}
      <Dialog
        open={loading}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent sx={{px: "20px"}}>
          <DialogContentText id="alert-dialog-slide-description" style={{display:"flex", alignItems: "center"}}>
            <CircularProgress style={{"marginRight": "40px"}} color='secondary'/> Cargando... 
          </DialogContentText>
        </DialogContent>
      </Dialog>
      

      <div style={{'display':` ${formEnviado ? 'none' : ''}`}}>
      {!hayParametroModulo && <Accordion style={{"margin": "0px"}} expanded={!traminteEnviado}>
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          style={{ pointerEvents: 'none'}}
        >
          <div>
            <Typography sx={textoPreguntas} >
            {traminteEnviado ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >1</Button>}
              ¿De qué área desea obtener un turno?
            </Typography>
            {traminteEnviado && <Typography sx={respuestaElegida}>
              {nombreModulo}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0px'}}>
            <Formik
            initialValues={{
            tramite: "",
            }}

            validate={(valores) =>{
            let errores = {};
            if (!valores.tramite) {
                errores.tramite = "Seleccione una opción.";
            }
            return errores;
            }}

            onSubmit={async(valores) =>{
                setDatos({...datos, idModulo: valores.tramite});   
                await delegacionesPorModulo(setDelegaciones, valores.tramite, setLoading);
                setTraminteEnviado(true);
            }}>

            {( { errors,} ) => (
              <Form className='formulario'>
                {modulos && <div name="tramite">
                    {modulos.map(tramite => 
                    
                        <label className='opciones' key={tramite.idModulo}>
                             <Field key={tramite.idModulo} type="radio" name="tramite" value={tramite.idModulo} onClick={() => {setNombreModulo(tramite.nombreModulo); if(tramite.idModulo == idModuloDeportes) setNecesitaCheckDNI(true); else setNecesitaCheckDNI(false);}} /> {tramite.nombreModulo} 
                        </label>
                    
                    )}
                    <ErrorMessage name="tramite" component={() => (<div className='error'>{errors.tramite}</div>)} />
                </div>}
                <div className='buttonContainer'>
                  <Button type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>}

      {necesitaCheckDNI && <Accordion style={{"margin": "0px"}} expanded={traminteEnviado && !esDNIValido} >
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <div>
            <Typography sx={textoPreguntas} >
            <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button>
              DNI
            </Typography>
            {esDNIValido && <Typography sx={respuestaElegida}>
              {datos.dniUser}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{dni: ""}}
            validationSchema={Yup.object().shape({
              dni: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')")
                  .required("Ingrese un DNI")})}
            
            onSubmit={async(valores) =>{

              const checkAux = await DNIestaRegistrado(valores.dni, setLoading);
              console.log(checkAux)

              if (checkAux.registered && !checkAux.isBookingEnabled) {
                setEsDNIValido(true);
                setDatos({...datos, dniUser: valores.dni});
              }
              else if (checkAux.isBookingEnabled){
                setAviso(
                  <div>
                    <p> Su DNI se encuentra bloqueado, para desbloquearlo deberá acercarse a la sede de Deportes correspondiente</p>
                  </div>
                )
                handleOpen()
              }
              else{
                setAviso(
                  <div>
                    <p> Usted no se encuentra registrado como Usuario Asociado de la Secretaría de Deportes. Si deseas asociarte, hace clic <b><a href="http://www.vicentelopez.gov.ar/mibarriovecinos/Account/Login" target="_blank">ACÁ</a></b></p>
                  </div>
                )
                handleOpen()
              }
            }}>
            {( { errors, }) => (
                <Form className='formulario'>
                  <div>
                      <CampoDeTexto 
                      type="number" 
                      id="dni" 
                      name='dni'
                      label="DNI"
                      />
                  </div>                  
                  <div className='buttonContainer'>
                  {!hayParametroModulo && <button type='button' className='formulario-atrasButton' onClick={() => {setTraminteEnviado(false);}}>Atras</button>}
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
                
        </AccordionDetails>
      </Accordion>}

      {false && <Accordion style={{"margin": "0px"}} expanded={checked && esDNIValido && !enviadosDatosInteresado} >
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <div>
            <Typography sx={textoPreguntas} >
            <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button>
              Datos del tercero
            </Typography>
            {/* {esDNIValido && <Typography sx={respuestaElegida}>
              {datos.dniUser}
            </Typography>} */}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{dni: ""}}
            validationSchema={Yup.object().shape({
              dniInteresado: Yup.number()
                  .typeError("Ingrese un DNI válido (sin espacios ni '.')")
                  .required("Ingrese un DNI"),
              nombreInteresado: Yup.string()
                  .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un nombre válido')
                  .required("Ingrese un nombre"),
              apellidoInteresado: Yup.string()
                  .matches(/^[a-zA-ZÀ-ÿ\s]{1,40}$/ , 'Ingrese un apellido válido')
                  .required("Ingrese un apellido"),
              })}
            
            onSubmit={async(valores) =>{

              setDatos({...datos, 
                dniInteresado: valores.dniInteresado, 
                nombreInteresado: valores.nombreInteresado, 
                apellidoInteresado: valores.apellidoInteresado, });

              setEnviadosDatosInteresado(true);
              
            }}>
            {( { errors, }) => (
                <Form className='formulario'>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="number" 
                      id="dniInteresado" 
                      name='dniInteresado'
                      label="DNI del interesado"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="nombreInteresado" 
                      name='nombreInteresado'
                      label="Nombre del interesado"
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="apellidoInteresado" 
                      name='apellidoInteresado'
                      label="Apellido del interesado"
                      />
                  </div>
                  <div className='buttonContainer'>
                  <button type='button' className='formulario-atrasButton' onClick={() => {setChecked(false); setEsDNIValido(false)}}>Atras</button>
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
                
        </AccordionDetails>
      </Accordion>}

      {!hayParametroDependencia && <Accordion style={{"margin": "0px"}} expanded={traminteEnviado && !ubicacionEnviada && ((necesitaCheckDNI && esDNIValido) || !necesitaCheckDNI) && (enviadosDatosInteresado || !checked)}>
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <div>
            <Typography sx={textoPreguntas} >
              {ubicacionEnviada ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroModulo? 1 : 2}</Button>}
              ¿Dónde realizará el trámite/actividad?
            </Typography>
            {ubicacionEnviada && <Typography sx={respuestaElegida}>
              {nombreDelegacion}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{
              ubicacion: "",
              }}

            validate={(valores) =>{
            let errores = {};

            if (!valores.ubicacion) {
                errores.ubicacion = "Seleccione una opción.";
            }

            return errores;
            }}

            onSubmit={async(valores) =>{
                setDatos({...datos, idDelegacion: valores.ubicacion});
                setUbicacionEnviada(true);
                let a = await serviciosPorDelegacion(setServicios, valores.ubicacion, setLoading);
                a.filter(serv => serv.activo == "1").map(tipoTramite => cargarOpcionesServicio(tipoTramite))
            }}>

            {( { errors, values}) => (
              <Form className='formulario'>
                     {traminteEnviado && !delegaciones.status && 
                    <div>
                        {delegaciones.filter(delegacion => delegacion.activo === "1").map(ubicacion => 
                        <>
                            <label className='opciones'>
                                <Field key={ubicacion.idDelegacion} 
                                type="radio" 
                                name="ubicacion" 
                                value={ubicacion.idDelegacion} 
                                onClick={() =>{
                                  if(ubicacion.idDelegacion == idDepCulMunro) setNecesitaCheckDNICultura(true); 
                                  else setNecesitaCheckDNICultura(false);
                                  setNombreDelegacion(ubicacion.nombreDelegacion);
                                  setAviso(<div dangerouslySetInnerHTML={{ __html: ubicacion.descripcionDelegacion }} />);
                                  if(ubicacion.descripcionDelegacion) handleOpen();
                                  }} /> {ubicacion.nombreDelegacion}
                            </label>
                        </>
                        )}
                    <ErrorMessage name="ubicacion" component={() => (<div className='error'>{errors.ubicacion}</div>)} />
                    </div>}
                    {traminteEnviado && delegaciones.status &&
                      <div>
                        <p>No hay dependencias cargadas.</p>
                      </div>
                    }
                <div className='buttonContainer'>
                  {(!hayParametroModulo && !necesitaCheckDNI) && <button type='button' className='formulario-atrasButton' onClick={() => {setTraminteEnviado(false); setDelegaciones(null); values.ubicacion=null; setEsDNIValido(false); setEnviadosDatosInteresado(false)}}>Atras</button>}
                  <Button disabled={loading} type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>}

      {!hayParametroServicio && <Accordion style={{"margin": "0px"}} expanded={ubicacionEnviada && !tipoTraminteEnviado} >
        <AccordionSummary
          style={{ pointerEvents: 'none', padd: "0.75% 0% 0.75%" }}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <div>
            
            <Typography sx={textoPreguntas}>
              {tipoTraminteEnviado ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroDependencia? 1 : (hayParametroModulo? 2 : 3)}</Button>}
              
              Seleccione {datos.idDelegacion==idDepCulMunro? "la función a la que desea asistir" : "tipo de trámite/actividad"}
            </Typography>
            {tipoTraminteEnviado && <Typography sx={respuestaElegida}>
              {nombreServicio}
            </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={{
            tipoTramite: "",
            }}
            
            validate={(valores) =>{
            let errores = {};

            if (!selectedOptions.idServicio) {
                errores.tipoTramite = "Seleccione una opción.";
            }

            return errores;
            }}

            onSubmit={async(valores) =>{
              if (idServicioTenis.includes(selectedOptions.idServicio)) {
                setOpenDNI(true)
              }
              else{
                diasDisponibles = await diasPorServicio(selectedOptions.idServicio, defaultDay.month, defaultDay.year, setLoading, {dni: [`${datos.dniUser}`]});
                if ((necesitaCheckDNICultura && cantidadTurnos < 1) && (selectedOptions.cupoMaximo > 1)) {
                  setAviso(
                      <div>
                        <p>
                        {"Por favor seleccione el número de entradas que desea reservar."}
                        </p>
                      </div>
                    );
                    handleOpen();
                }
                else if (diasDisponibles.status !== "error") {
                    setDatos({...datos, idServicio: selectedOptions.idServicio, cantidad: cantidadTurnos});
                    setTipoTraminteEnviado(true);
                    habilitarDias();
                    // abrirPrimerDia(diasDisponibles, selectedOptions.idServicio);
                    await setDisabledDays(disabledDaysAux);
                  }
                  else{
                    setAviso(
                      <div>
                        <p>
                        {datos.idDelegacion==idDepCulMunro? "Entradas agotadas." :"El trámite/actividad seleccionado no posee turnos disponibles."}
                        </p>
                      </div>
                    );
                    handleOpen();
                  }
              }
            }}>

            {( { errors, values}) => (
                <Form className='formulario'>
                    {ubicacionEnviada && (opcionesServicios.length > 0) &&
                        <div className="select-box">
                          
                            <Select
                              placeholder={"Seleccione uno..."}
                              options={opcionesServicios}
                              onChange={(item) => {
                                setSelectedOptions(item.value);
                                console.log(item.value)
                                setNombreServicio(item.value.nombre);
                                setAviso(<div dangerouslySetInnerHTML={{ __html: item.value.descripcionServicio }} />);
                                if(item.value.descripcionServicio) handleOpen();
                              }}
                              className="select"
                              isClearable={false}
                              isSearchable={true}
                              isDisabled={false}
                              isLoading={loading}
                              isRtl={false}
                              closeMenuOnSelect={true}
                              onFocus={desaparecerLupa}
                              onBlur={aparecerLupa}
                              menuPortalTarget={datos.idDelegacion==idDepCulMunro? document.body : null}
                            />
                        
                            {necesitoLupita && <SearchIcon color="disabled" className='lupa-select' />}

                            {selectedOptions && <>{idServicioTenis.includes(selectedOptions.idServicio) && 
                              <div style={{"display":"flex", "textAlign":"left", "alignItems": "center"}}>
                              <Checkbox
                                checked={checkedTenisDouble}
                                onChange={manejarTenisDouble}
                                inputProps={{ 'aria-label': 'controlled' }}
                                color="secondary"
                              />
                              <p style={{"display":"inline-block"}}>Tenis doble</p>
                            </div>}</>}

                            
                            {((necesitaCheckDNICultura || datos.idDelegacion == idDepCulMunro) && selectedOptions) && 
                            <>
                              {selectedOptions.cupoMaximo > 1 && <div style={{ display: 'flex', alignItems: 'center', margin: "10px 0px 0px 5px"}}>
                                <p style={{ marginRight: '10px' }} >¿Cuantas entradas desea reservar?</p>
                                <select className="custom-select" value={cantidadTurnos} onChange={(event) => {
                                  console.log(datos, parseInt(event.target.value));
                                  setCheckedTurnoDoble(parseInt(event.target.value) > 1);
                                  setCantidadTurnos(parseInt(event.target.value));
                                }}>
                                  <option value={0}>Seleccione</option>
                                  {[...Array(parseInt(selectedOptions.cupoMaximo))].map((_, index) => (
                                    <option key={index + 1} value={index + 1}>{index + 1}</option>
                                  ))}
                                </select>
                              </div>}
                              </>}

                            {/* {(necesitaCheckDNICultura || datos.idDelegacion == idDepCulMunro) && <> 
                              <div style={{"display":"flex", "textAlign":"left", "alignItems": "center"}}>
                              <Checkbox
                                checked={checkedTurnoDoble}
                                onChange={manejarTurnoDoble}
                                inputProps={{ 'aria-label': 'controlled' }}
                                color="secondary"
                              />
                              <p style={{"display":"inline-block"}}>Turno doble</p>
                            </div></>} */}
                        
                    <ErrorMessage name="tipoTramite" component={() => (<div className='error'>{errors.tipoTramite}</div>)} />
                    </div>}
                    {opcionesServicios.length<=0 &&
                      <div>
                        <p>No hay {datos.idDelegacion==idDepCulMunro? "funciones" : "trámites/actividades"} cargadas.</p>
                      </div>
                    }

                <div className='buttonContainer'>
                  {!hayParametroDependencia && <button type='button' className='formulario-atrasButton' onClick={() => {setUbicacionEnviada(false); setServicios(null); setOpcionesServicios([]); setSelectedOptions(null);setDatos({...datos, cantidad: null})}}>Atras</button>}
                  <Button disabled={loading} type='submit'>Siguiente</Button>
                </div>
                </Form>
            )}

            </Formik>
        </AccordionDetails>
      </Accordion>}
      
      <Accordion style={{"margin": "0px"}} expanded={tipoTraminteEnviado && !fechaEnviada} >
        <AccordionSummary
          style={{ pointerEvents: 'none'}}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <div>
            <Typography sx={textoPreguntas}>
              {fechaEnviada ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroServicio? "1" : (hayParametroDependencia? 2 : (hayParametroModulo? 3 : 4))}</Button>}
               
              Seleccione fecha {datos.idDelegacion==idDepCulMunro? "de la función" : "del trámite/actividad"}
            </Typography>
            {fechaEnviada && <Typography sx={respuestaElegida}> {datos.diaCompleto} {datos.hora} </Typography>}
          </div>
        </AccordionSummary>
        <AccordionDetails>
            <div style={{display: "flex", justifyContent: "center", fontWeight: "bold"}}>
              <Calendar
                  locale={myCustomLocale}
                  value={selectedDay}
                  onChange={async(dia)=> {
                    setHoras([]);
                    setSelectedDay(dia);
                    setDatos({...datos, hora: ""});
                    const horaAux = await horasPorDia(setHoras, datos.idServicio, dia.day, dia.month, dia.year, setLoading);
                    noHayHoras(horaAux);
                    setMostrarHoras(true);
                  }}
                  minimumDate={utils().getToday()}
                  maximumDate={{...defaultDay, year: (defaultDay.year + 1), month: (defaultDay.month - 1)}}
                  disabledDays={disabledDays} // here we pass them
                  onDisabledDayError={handleDisabledSelect} // handle error
                  calendarClassName="responsive-calendar" 
              />
            </div>

            <div style={{marginTop: "2%", marginBottom: "2%", "minHeight":"100px", "paddingTop": "10px"}}>
              {mostrarHoras && horas.status != "error" && !mostrarNoHayHoras && <p> {datos.idDelegacion==idDepCulMunro? "Seleccione un horario" : "Seleccione una hora"}:</p>}
              {mostrarHoras && horas.status != "error" && 
              <div style={{"flexWrap": "wrap", "justifyContent": "space-between"}}>
                {horas.filter(horario => horario.cupo > 0).map(horario => 
                  <>
                    <ThemeProvider theme={theme}>
                      <Button 
                        style={{"margin": "4px 5px", "borderRadius": "8px", "width": "55px" }}
                        key={horario.hora} 
                        value={horario.hora} 
                        color={(horario.hora === datos.hora) ? "secondary" : "desmarcado"}
                        variant="contained"
                        onClick={() => {
                          setDatos({...datos, hora: horario.hora});
                        }}> 
                        {horario.hora}</Button>
                    </ThemeProvider>
                  </>
                  )}
              </div>}
                  {mostrarNoHayHoras && <p>No hay horarios disponibles</p>}
            </div>
            <div className='buttonContainer'>
              {!hayParametroServicio && <button type='button' className='formulario-atrasButton' onClick={() => {setTipoTraminteEnviado(false); setDatos({...datos, hora: null}); setMostrarHoras(false); setDatos({...datos, interesados: []})}}>Atras</button>}
              <Button 
                type='submit' 
                disabled={!datos.hora} 
                onClick={() => {
                  setDatos({...datos, diaCompleto: (selectedDay.year + "-"+ selectedDay.month + "-" + selectedDay.day), dia: fechaADia(selectedDay)});
                  setFechaEnviada(true);
                  // if (datos.idDelegacion == idDepCulMunro) {
                  //   setAviso(
                  //     <div>
                  //       <p> Por favor, valide su DNI presionando el botón debajo del campo "numero de documento". Recuerde, no está permitido realizar 2 reservas con el mismo documento. </p>
                  //     </div>
                  //   )
                  //   handleOpen()
                  // }
                }}>Siguiente</Button>
            </div>
        </AccordionDetails>
      </Accordion>

      <Accordion style={{"margin": "0px"}} expanded={fechaEnviada && !datosPersonalesEnviados} >
        <AccordionSummary
          style={{ pointerEvents: 'none' }}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography sx={{...textoPreguntas, "textAlign":"left" }}>
              {datosPersonalesEnviados ? <Button color='primary' variant='contained' style={iconosPreguntas} ><CreateSharp style={{"minWidth": "20", "width": "20"}} /></Button> : <Button color='primary' variant='contained' style={iconosPreguntas} >{hayParametroServicio? "2" : (hayParametroDependencia? 3 : (hayParametroModulo? 4 : 5))}</Button>}
            
            Datos personales 
          </Typography>
          {/* {fechaEnviada && <Typography sx={respuestaElegida}>  </Typography>}  */}
        </AccordionSummary>
        <AccordionDetails>
            <Formik
            initialValues={VALORES_INICIALES}
            validationSchema={elegirEsquemaVal()}
            validate={(valores) =>{
              let errores = {};
              
              // DESCOMENTAR PARA LOCALIDADES
              // if (necesitaCheckDNICultura) {
              //   if (!datos.localidadUser) {
              //       errores.tipoTramite = "Seleccione una opción.";
              //   }
              // }
  
              return errores;
              }}

            onSubmit={async(valores) =>{
                let mailAux = valores.correo;
                if (mailAux.slice(-1) == '.') {
                  mailAux = mailAux.slice(0, -1);
                }
                setDatos({...datos,
                    nombreUser: valores.nombre,
                    apellidoUser: valores.apellido,
                    direccionUser: valores.domicilio,
                    emailUser: mailAux,
                    telUser: valores.celular,
                });
                let payloadAux = {...datos,
                  nombreUser: valores.nombre,
                  apellidoUser: valores.apellido,
                  direccionUser: valores.domicilio,
                  emailUser: mailAux,
                  telUser: valores.celular,}

                // CASO NIÑEZ
                if (datos.idDelegacion == idDelNiniez) {
                  if (checkedNinio || datos.idServicio == idSocialNinies[1]) {
                    if ((!valores.nombreNinio || !valores.apellidoNinio || !valores.dniNinio) || (checkedNinio && !valores.entidad)) {
                      setAviso(
                        <div>
                          <p> Por favor, rellenar todos los campos </p>
                        </div>
                      )
                      handleOpen()
                      return;
                    }
                  }
                  setDatos({...datos, dniUser: valores.dni, interesados:[{nombre: valores.nombreNinio, apellido: valores.apellidoNinio}]});
                  payloadAux.dniUser = valores.dni;
                  payloadAux.interesados = [{dni: valores.dniNinio,nombre: valores.nombreNinio, apellido: valores.apellidoNinio}];
                  if (checkedNinio) {
                    setDatos({...datos, entidad: valores.entidad});
                    payloadAux.entidad = valores.entidad;
                  }
                  await setNuevoTurnoInfo(await insertarTurno(payloadAux, setLoading));
                  setDatosPersonalesEnviados(true);
                  setFormEnviado(true);
                }
                // CASO NORMAL
                else if (!necesitaCheckDNI) {
                  setDatos({...datos, dniUser: valores.dni});
                  payloadAux.dniUser = valores.dni;
                  await setNuevoTurnoInfo(await insertarTurno(payloadAux, setLoading));
                  setDatosPersonalesEnviados(true);
                  setFormEnviado(true);
                }
                // CASO DEPORTES TERCEROS
                else if(checked){
                  const checkAux = await DNIestaRegistrado(valores.dniInteresado, setLoading);

                  if (payloadAux.interesados) {
                    
                    payloadAux = {...payloadAux, 
                      interesados: [{dni: valores.dniInteresado, 
                      nombre: valores.nombreInteresado, 
                      apellido: valores.apellidoInteresado}, ...payloadAux.interesados]}
                  }
                  else {payloadAux = {...payloadAux, 
                    interesados: [{dni: valores.dniInteresado, 
                    nombre: valores.nombreInteresado, 
                    apellido: valores.apellidoInteresado}]}}
                    
                    if (checkAux.registered && !checkAux.isBookingEnabled && (datos.dniUser !== valores.dniInteresado) && sinDuplicados(valores.dniInteresado, payloadAux.interesados)) {
                    setDatos({...datos,
                      interesados: [{dni: valores.dniInteresado, 
                        nombre: valores.nombreInteresado, 
                        apellido: valores.apellidoInteresado}, ...datos.interesados]})
                    await setNuevoTurnoInfo(await insertarTurno(payloadAux, setLoading));
                    setDatosPersonalesEnviados(true);
                    setFormEnviado(true);
                  }
                  else if (!(datos.dniUser !== valores.dniInteresado) || !(sinDuplicados(valores.dniInteresado, payloadAux.interesados))){
                    setAviso(
                      <div>
                        <p> Por favor, no ingresar DNI duplicado </p>
                      </div>
                    )
                    handleOpen()
                  }
                  else if (checkAux.isBookingEnabled){
                    setAviso(
                      <div>
                        <p> Su DNI se encuentra bloqueado, para desbloquearlo deberá acercarse a la sede de Deportes correspondiente.</p>
                      </div>
                    )
                    handleOpen()
                  }
                  else if (!checkAux.registered){
                    setAviso(
                      <div>
                        <p> El DNI del interesado no se encuentra registrado como Usuario Asociado de la Secretaría de Deportes. Si deseas asociarlo, hace clic <b><a href="http://www.vicentelopez.gov.ar/mibarriovecinos/Account/Login" target="_blank">ACÁ</a></b></p>
                      </div>
                    )
                    handleOpen()
                  }
                }
                // CASO DEPORTES NORMAL
                else{
                  await setNuevoTurnoInfo(await insertarTurno(payloadAux, setLoading));
                  setDatosPersonalesEnviados(true);
                  setFormEnviado(true);
                }
            }}>
            {( { errors, handleSubmit, handleChange, handleBlur, values}) => (
                <Form className='formulario'>
                  {!necesitaCheckDNI && <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="number" 
                      id="dni" 
                      name='dni'
                      label="Número de documento"
                      style={{"width": "50%", "minWidth": "239px"}}
                      onChange={(e) => {
                        handleChange(e);
                        values.nombre = "";
                        values.apellido = "";
                        values.domicilio = "";
                        values.correo = "";
                        values.celular = "";
                        setEsDNIValido(false);
                      }}
                      />
                  </div>}
                  {necesitaCheckDNICultura && 
                  <div className='buttonContainer' style={{"marginLeft": "17px"}}>
                    <button type='button' className='formulario-atrasButton' onClick={() => {setFechaEnviada(false); setChecked(false);
                        if (datos.idDelegacion==idDepCulMunro) {
                          setEsDNIValido(false); 
                          values.dni = "";
                          values.nombre = "";
                          values.apellido = "";
                          values.domicilio = "";
                          values.correo = "";
                          values.celular = "";
                        }
                        }}>Atras</button>
                    <Button disabled={loading} type='submit' onClick={() => {
                      verificarDNICultura(values.dni);
                      }}>Validar</Button>
                  </div>}
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="nombre" 
                      name='nombre' 
                      label="Nombre"
                      disabled={(!esDNIValido && necesitaCheckDNICultura)}
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="apellido" 
                      name='apellido' 
                      label="Apellido"
                      disabled={(!esDNIValido && necesitaCheckDNICultura)}
                      />
                  </div>
                  {/*  DESCOMENTAR PARA LOCALIDADES 1275 */}
                  {false && <div className='select-box2' style={{"marginLeft": "17px", "textAlign": "left", "width": "72%"}}>
                    <Select
                      placeholder={"Localidad..."}
                      options={barrio}
                      onChange={(item) => {
                        setDatos({...datos, localidadUser: item.label, localidadCode: item.value})
                        console.log(datos.localidadUser + " " + datos.localidadCode)
                        console.log(item.label + " " + item.value)
                      }}
                      className="select"
                      isClearable={false}
                      isDisabled={(!esDNIValido && necesitaCheckDNICultura)}
                      isSearchable={true}
                      isLoading={loading}
                      isRtl={false}
                      closeMenuOnSelect={true}
                      onFocus={desaparecerLupa}
                      onBlur={aparecerLupa}
                      menuPortalTarget={datos.idDelegacion==idDepCulMunro? document.body : null}
                      style={{"min-width": "400px"}}
                    />
                        
                    {necesitoLupita && <SearchIcon color="disabled" className='lupa-select' />}
                    {/* <div className='error' style={{"margin": "auto"}}>{errors.tipoTramite}</div> */}
                    {/* <ErrorMessage name="tipoTramite" component={() => (<div className='error'>{errors.tipoTramite}</div>)} /> */}
                  </div>}
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="domicilio" 
                      name='domicilio' 
                      label={"Domicilio"}
                      disabled={(!esDNIValido && necesitaCheckDNICultura)}
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="correo" 
                      name='correo' 
                      label="Email"
                      disabled={(!esDNIValido && necesitaCheckDNICultura)}
                      />
                  </div>
                  <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                      <CampoDeTexto 
                      type="text" 
                      id="celular" 
                      name='celular' 
                      label="Celular"
                      disabled={(!esDNIValido && necesitaCheckDNICultura)}
                      />
                  </div>

                  {/* CHECK-BOXES ESPECIALES */}
                  {necesitaCheckDNI && <div style={{"display":"flex", "textAlign":"left", "marginLeft": "20px", "alignItems": "center"}}>
                    <Checkbox
                      checked={checked}
                      onChange={manejarInvitado}
                      inputProps={{ 'aria-label': 'controlled' }}
                      color="secondary"
                    />
                    <p style={{"display":"inline-block"}}>Sacar el turno a un tercero</p>
                  </div>}
                  {(datos.idServicio == idSocialNinies[0]) && <div style={{"display":"flex", "textAlign":"left", "marginLeft": "20px", "alignItems": "center"}}>
                    <Checkbox
                      checked={checkedNinio}
                      onChange={manejarCheckedNiniez}
                      inputProps={{ 'aria-label': 'controlled' }}
                      color="secondary"
                    />
                    <p style={{"display":"inline-block"}}>Represento una escuela</p>
                  </div>}

                  {/* FORMULARIO INTERESADOS */}
                  {checked &&
                    <>
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="number" 
                          id="dniInteresado" 
                          name='dniInteresado'
                          label="DNI del interesado"
                          />
                      </div>
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="text" 
                          id="nombreInteresado" 
                          name='nombreInteresado'
                          label="Nombre del interesado"
                          />
                      </div>
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="text" 
                          id="apellidoInteresado" 
                          name='apellidoInteresado'
                          label="Apellido del interesado"
                          />
                      </div>
                    </>
                  }

                  {/* FORMULARIO NIÑOS */}
                  {(checkedNinio || datos.idServicio == idSocialNinies[1]) &&
                    <>
                      {checkedNinio && 
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="text" 
                          id="entidad" 
                          name='entidad'
                          label="Nombre de la institución"
                          />
                      </div>}
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="number" 
                          id="dniNinio" 
                          name='dniNinio'
                          label="DNI del niño"
                          />
                      </div>
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="text" 
                          id="nombreNinio" 
                          name='nombreNinio'
                          label="Nombre del niño"
                          />
                      </div>
                      <div style={{"marginLeft": "17px", display: "flex", justifyContent: "flex-start", "width": "75%"}}>
                          <CampoDeTexto 
                          type="text" 
                          id="apellidoNinio" 
                          name='apellidoNinio'
                          label="Apellido del niño"
                          />
                      </div>
                    </>
                  }

                  <div className='buttonContainer' style={{"marginLeft": "17px"}}>
                    <button type='button' className='formulario-atrasButton' onClick={() => {
                      setFechaEnviada(false); 
                      setChecked(false);
                      if(necesitaCheckDNICultura) setEsDNIValido(false);
                      setDatos({...datos, localidadUser: ""})
                      values.dni = "";
                      values.nombre = "";
                      values.apellido = "";
                      values.domicilio = "";
                      values.correo = "";
                      values.celular = "";}}>Atras</button>
                    <Button disabled={loading} type='submit'>Siguiente</Button>
                  </div>
                </Form>
            )}
            </Formik>
                
        </AccordionDetails>
      </Accordion>
      </div>
      {/* <button type='button' onClick={() => (console.log(datos))}>Ver Datos</button> */}
      {nuevoTurnoInfo && formEnviado && <>
      {nuevoTurnoInfo.status === "ok" && <NuevoTurno nombre={nuevoTurnoInfo.nombre} dni={nuevoTurnoInfo.dni} modulo={nuevoTurnoInfo.modulo? nuevoTurnoInfo.modulo.nombre : ""} dependencia={nuevoTurnoInfo.dependencia? nuevoTurnoInfo.dependencia.nombre : ""} codigo={nuevoTurnoInfo.codigo} fecha={nuevoTurnoInfo.fecha} qr={nuevoTurnoInfo.qr} hora={nuevoTurnoInfo.hora} lugar={nuevoTurnoInfo.lugar} servicio={nuevoTurnoInfo.servicio? nuevoTurnoInfo.servicio.nombre : ""} mostrarInteresado={checked} dniInteresado={(nuevoTurnoInfo.interesados && checked) ? nuevoTurnoInfo.interesados[0].dni : null} nombreInteresado={(nuevoTurnoInfo.interesados && checked) ? nuevoTurnoInfo.interesados[0].nombre : null} apellidoInteresado={(nuevoTurnoInfo.interesados && checked) ? nuevoTurnoInfo.interesados[0].apellido : null} idDependencia={datos.idDelegacion} idCulMunro={idDepCulMunro} />}
      {nuevoTurnoInfo.status === "error" && 
        <Dialog
          open={true}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{"textAlign": "center", "color": "#97077D", "fontWeight": "bold"}} >{"Importante:"}</DialogTitle>
          <DialogContent sx={{px: "40px"}}>
            <DialogContentText id="alert-dialog-slide-description">
            {nuevoTurnoInfo.data}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => {
                  window.location.reload();
                }}>Entendido
            </Button>
          </DialogActions>
        </Dialog>}
      </>}
    </div>
  );
}
